var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 44,
    viewBox: "0 0 60 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_36)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9115 3.1579H10.0885C7.15601 3.1579 4.77876 5.51429 4.77876 8.42106V28.4211C4.77876 31.3278 7.15601 33.6842 10.0885 33.6842H49.9115C52.844 33.6842 55.2212 31.3278 55.2212 28.4211V8.42106C55.2212 5.51429 52.844 3.1579 49.9115 3.1579Z",
    fill: "url(#paint0_linear_2_36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9115 3.42105H10.0885C7.30264 3.42105 5.04425 5.65963 5.04425 8.42105V28.4211C5.04425 31.1825 7.30264 33.4211 10.0885 33.4211H49.9115C52.6974 33.4211 54.9558 31.1825 54.9558 28.4211V8.42105C54.9558 5.65963 52.6974 3.42105 49.9115 3.42105Z",
    stroke: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.7706 8.12843C49.9588 9.4358 47.3145 9.64896 46.0981 8.53001L45.6945 8.8779C45.686 8.88517 45.676 8.89041 45.6651 8.89324C45.6542 8.89607 45.6429 8.89641 45.6319 8.89422C45.6209 8.89204 45.6105 8.8874 45.6016 8.88065C45.5926 8.8739 45.5854 8.86522 45.5804 8.85527L45.3919 8.47369C45.3869 8.46491 45.385 8.45471 45.3866 8.44475C45.3882 8.43884 45.3913 8.43342 45.3956 8.42896L45.7397 8.05001L45.3972 7.67054C45.3923 7.66625 45.3887 7.66082 45.3866 7.65475C45.3846 7.64427 45.3865 7.63344 45.3919 7.62422L45.5825 7.24369C45.5875 7.23375 45.5948 7.22507 45.6037 7.21832C45.6126 7.21157 45.623 7.20693 45.634 7.20474C45.645 7.20256 45.6564 7.2029 45.6672 7.20573C45.6781 7.20855 45.6881 7.2138 45.6966 7.22106L46.0975 7.56738C47.3113 6.44633 49.9582 6.65896 50.7701 7.96685C50.7849 7.99124 50.7927 8.01913 50.7928 8.04757C50.7929 8.07601 50.7852 8.10395 50.7706 8.12843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5653 7.92895C49.7061 7.92895 49.8202 7.81585 49.8202 7.67632C49.8202 7.5368 49.7061 7.42369 49.5653 7.42369C49.4246 7.42369 49.3104 7.5368 49.3104 7.67632C49.3104 7.81585 49.4246 7.92895 49.5653 7.92895Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_36",
    x: -1.45575,
    y: -0.078949,
    width: 62.9115,
    height: 43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_36"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_36",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_36",
    x1: 6.8469,
    y1: 4.56211,
    x2: 31.4269,
    y2: 46.0635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EBEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2772AF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_36"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.8f629c090b7ee8b83c9ee12b6a2b8454.svg";
export { ForwardRef as ReactComponent };